import { SonarScopedDashboardPage } from './sonar/shared/components/SonarScopedDashboardPage';

export const TribeQualityViewPage = () => (
  <SonarScopedDashboardPage initialScope="tribe" />
);
